export default function createSharePointDownloadUrl(
    groupSharePointUrl: string,
    fileSharePointId: string
): string {
    if (groupSharePointUrl && fileSharePointId) {
        return `${groupSharePointUrl}/_layouts/15/download.aspx?UniqueId=${fileSharePointId}`;
    }

    return null;
}
